import { MODALS, useModal } from '../../../context/ModalProvider'
import BookPackageHeader from '../../../features/book-management/book-package/BookPackageHeader'
import BookPackageList from '../../../features/book-management/book-package/BookPackageList'
import CreateBookPackageModal from '../../../features/book-management/book-package/CreateBookPackageModal'

export default function BookPackagePage() {
  const { state } = useModal()

  return (
    <>
      <BookPackageHeader />
      <BookPackageList />
      {state === MODALS.ADD_BOOK_PACKAGE && <CreateBookPackageModal />}
    </>
  )
}
